import { useState } from 'react';

import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSendCommitteeControlDecisionMutation } from 'services';
import { useApiErrorMessage } from 'hooks';
import { fetchError } from 'slices/commonSlice';
import { committeeDecisions, openNotification } from 'utils';

/**
 * İH - Tercüme (54) aşamasının madde detayındaki aksiyonları: tercüme yükleme ekranına giriş ve
 * maddeyi tercümeden geri çekme.
 *
 * Geri çekme tercüme ucundan (`committee_translation`) değil, İH - Madde Kontrol ucundan
 * (`committee_control`) `pullback` kararıyla yapılır. Yıkıcı değildir: yüklenmiş dosya sürümleri
 * olduğu gibi kalır, yalnız madde İH - Madde Kontrol'e döner.
 */
const TranslationStepActions = ({ offerId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getErrorMessage = useApiErrorMessage();
  const [sendCommitteeControlDecision, { isLoading: isReverting }] = useSendCommitteeControlDecisionMutation();
  const [isRevertConfirmVisible, setIsRevertConfirmVisible] = useState(false);

  const handleRevertFromTranslation = async () => {
    const { error } = await sendCommitteeControlDecision({
      id: offerId,
      body: {
        status: committeeDecisions.pullback,
      },
    });

    if (error) return dispatch(fetchError(getErrorMessage(error)));

    setIsRevertConfirmVisible(false);
    openNotification({ message: 'Madde tercüme aşamasından geri çekildi' });
  };

  return (
    <>
      <div className="modalBtnGrp">
        <Button
          className="modalBtnStyle"
          type="primary"
          onClick={() => navigate(`/tercume-yukle/${offerId}`)}
        >
          Tercümeyi Yükle
        </Button>
        <Button
          className="modalBtnStyle"
          onClick={() => setIsRevertConfirmVisible(true)}
        >
          Tercüme&apos;den Geri Çek
        </Button>
      </div>

      {/* Onay metni okunmadan istek atilmaz. */}
      <Modal
        title="Tercümeden Geri Çekilecek?"
        destroyOnClose
        open={isRevertConfirmVisible}
        okText="Geri Çek"
        cancelText="Vazgeç"
        confirmLoading={isReverting}
        onOk={handleRevertFromTranslation}
        onCancel={() => setIsRevertConfirmVisible(false)}
      >
        Maddeyi tercümeden geri çektiğinizde madde İlim Heyeti madde kontrol aşamasına döner. Şu ana kadar yüklenmiş dosya sürümleri korunur, hiçbiri silinmez.
      </Modal>
    </>
  );
};

export default TranslationStepActions;
